import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function BCFMain() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.bcf);
  const redeemUrl = GLOBAL_CFG["bcf"].redeem.redeemUrl;

  return (
    <>
      {!loading && (
          <OnboardingPage
            partnerCfg={GLOBAL_CFG["bcf"]}
            redeemUrl={redeemUrl}
            coupon={coupon}
            rewardId={REWARD_OFFERING.bcf}
          />
      )}
    </>
  );
}

export default BCFMain;
